<app-cancel-open-banking-popin (continue)="closePopin()" [show]="isPopinOpen"></app-cancel-open-banking-popin>

<div class="flex flex-col flex-1 justify-between h-full">
  <div class="text-center flex-1 content-center">
    <img src="../../../../../assets/images/svg/cross-error.svg" class="h-8 w-8 m-auto" />
    <p class="text-secondary font-bold mt-7 text-xl">{{ 'connection_attempt_has_failed' | translate }}</p>
    <p class="mt-3">{{ 'retry_with_another_bank_or_use_classic_form' | translate }}</p>
  </div>
  <div class="flex flex-col">
    <button
      class="bg-primary font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full"
      (click)="retryBankConnectionWithOpenBanking()"
    >
      {{ 'connect_to_another_bank' | translate }}
    </button>
    <button
      class="bg-gray-100 font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full text-sm"
      (click)="retryBankConnectionWithPartner()"
    >
      {{ 'come_back_to_classic_form' | translate }}
    </button>
  </div>
</div>
